import { render, staticRenderFns } from "./Suffix.vue?vue&type=template&id=1f65a6f8&"
import script from "./Suffix.vue?vue&type=script&lang=js&"
export * from "./Suffix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports